import i18n from 'i18next'
import i18nBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import { resolveLanguagePreference } from 'core/utils/language'

// Import modular translations
import { enTranslations } from './translations/en'
import { krTranslations } from './translations/kr'

const initialLanguage = resolveLanguagePreference()

i18n
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    fallbackLng: 'en',
    debug: false,
    detection: {
      order: ['cookie', 'localStorage', 'navigator'],
      caches: ['cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: enTranslations,
      },
      kr: {
        translation: krTranslations,
      },
    },
  })

export default i18n
